require('./brokerMyInvestmentsAssetsEmptyStates.scss');

const PropTypes = require('prop-types');
// @ vendor
const React = require('react');
// @ commons
const { EmptyState } = require('commonsComponents/emptyState');

// @components
const { BrokerMyInvestmentsWrappedAssetsTable } = require('../brokerMyInvestmentsWrappedAssetsTable/brokerMyInvestmentsWrappedAssetsTable');

// @helpers
const { formatText } = require('core/i18n').i18n;

class BrokerMyInvestmentsAssetsEmptyStates extends React.Component {

    render() {
        const { productType } = this.props;
        const title = formatText(`broker-investments${productType}TableTitle`);
        const typeString = formatText(`broker-investmentsActivosTableEmptyTextType`);

        let emptyState;

        emptyState = (
            <EmptyState
                primaryText={formatText(`broker-myInvestmentsProductsEmptyGeneralView`, [typeString])}
                iconType="noitems-wealth"
            />
        );

        return (
            <BrokerMyInvestmentsWrappedAssetsTable
                type={productType}
                productType={title}
                itemsNumber={0}
                earnings={0}
                earningsPercentage={0}
                total={0}
                capital={0}
                hasExcludedItems={false}
                onOpenTraderClick={this.props.onOpenTraderClick}
                setOrdersAndMovementsAccessFrom={this.props.setOrdersAndMovementsAccessFrom}
            >
                {emptyState}
            </BrokerMyInvestmentsWrappedAssetsTable>
        );
    }
}

BrokerMyInvestmentsAssetsEmptyStates.propTypes = {
    immMyWalletCharts: PropTypes.object,
    productType: PropTypes.string,
    onOpenTraderClick: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired
};

module.exports = BrokerMyInvestmentsAssetsEmptyStates;
